import React from 'react'
import {Checkbox, FormControlLabel, TextField} from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'

const FTextField = ({data, onChange = (e, key, value) => {}}) => {
  return (
    <>
      <TextField
        id="standard-number"
        value={data.start_value}
        label="Start Value for Increment"
        type="number"
        onChange={(e, value) => onChange(e, 'start_value')}
        InputLabelProps={{
          shrink: true,
        }}
      />
      <br />
      <TextField
        id="standard-required"
        label="Prefix"
        value={data?.prefix}
        onChange={(e, value) => onChange(e, 'prefix')}
        defaultValue=""
      />
      <br />
      <TextField
        id="standard-number"
        label="Total numeric digits"
        type="number"
        value={data.total_numeric_digits}
        onChange={(e, value) => onChange(e, 'total_numeric_digits')}
        InputLabelProps={{
          shrink: true,
        }}
      />
      <br />
      <FormControlLabel
        style={{marginBottom: 0}}
        control={
          <Checkbox
            onClick={e => onChange(e, 'allow_scanning', !(data?.allow_scanning || false))}
            size="small"
            checkedIcon={<CheckCircleIcon style={{color: '#3473ff'}} />}
            checked={data?.allow_scanning || false}
            name="required"
          />
        }
        label="Bar Code Scanner?"
      />
    </>
  )
}

export default FTextField
